// Hooks
import { useMessageFilter } from '@/utils/hooks/conversations/useMessageFilter';

// Constants/Libs
import { MESSAGE_FILTER_META } from '@/components/pages/conversations/SocialInbox/const';

// Components
import { ConversationFilters } from '@/components/pages/conversations/SocialInbox';

export const SocialInboxFilters = () => {
    const { messageFilter } = useMessageFilter();

    if (messageFilter === MESSAGE_FILTER_META.dm.key) {
        return null;
    }

    return <ConversationFilters />;
};
